// Copyright (c) 2025 by Audere

import { useSelector } from "react-redux";
import { useGetLabelerConversationsQuery } from "../features/api/labelApiSlice";
import { selectCurrentUserPersistentGroupRole } from "../features/slices/authSlice";
import { conversationLimit } from "../constants/conversation";

export const useLabelerConversations = (
  labelTypeID: string,
  offsetValue: number
) => {
  const userGroupRole = useSelector(selectCurrentUserPersistentGroupRole);
  const { data, isLoading, isFetching, error, refetch } =
    useGetLabelerConversationsQuery(
      {
        group: userGroupRole.group,
        labeling_type: labelTypeID,
        offset: offsetValue,
        limit: conversationLimit,
      },
      {
        pollingInterval: 10000,
        skipPollingIfUnfocused: true,
        refetchOnFocus: true,
        refetchOnReconnect: true,
        skip: !labelTypeID,
      }
    );

  const conversations = data?.conversations ?? [];
  const offset = data?.offset ?? 0;
  const endOfList = data?.end_of_list;

  return {
    conversations,
    offset,
    endOfList,
    isLoading,
    isFetching,
    error,
    refetch,
  };
};
